import React from 'react';
import { Button, Typography, Box, Paper, Switch, Divider } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

const SectionLabel = ({ children }) => (
  <Typography
    variant="overline"
    sx={{ color: 'text.secondary', fontWeight: 700, letterSpacing: '0.08em' }}
  >
    {children}
  </Typography>
);

const RowIcon = ({ children }) => (
  <Box
    sx={{
      width: 40,
      height: 40,
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'action.hover',
      color: 'primary.main',
      flexShrink: 0,
    }}
  >
    {children}
  </Box>
);

const SettingsRow = ({ icon, title, subtitle, control }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      padding: '16px 0',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px', minWidth: 0 }}>
      <RowIcon>{icon}</RowIcon>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
    {control}
  </Box>
);

const Settings = ({ themeMode, toggleTheme, onLogout }) => {
  const isDark = themeMode === 'dark';

  return (
    <Box sx={{ maxWidth: '640px', margin: 'auto', padding: '40px' }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, marginBottom: '24px' }}>
        Settings
      </Typography>

      <Paper sx={{ borderRadius: 3, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
        <Box sx={{ padding: '20px 24px 4px' }}>
          <SectionLabel>Appearance</SectionLabel>
          <SettingsRow
            icon={<DarkModeOutlinedIcon fontSize="small" />}
            title="Dark Mode"
            subtitle={`Currently using the ${themeMode} theme`}
            control={<Switch checked={isDark} onChange={toggleTheme} color="primary" />}
          />
        </Box>

        <Divider />

        <Box sx={{ padding: '20px 24px 4px' }}>
          <SectionLabel>Account</SectionLabel>
          <SettingsRow
            icon={<LogoutOutlinedIcon fontSize="small" />}
            title="Log out"
            subtitle="Sign out of your account on this device"
            control={
              <Button
                variant="contained"
                color="primary"
                disableElevation
                onClick={onLogout}
                sx={{ textTransform: 'none', borderRadius: '8px', paddingX: '18px' }}
              >
                Logout
              </Button>
            }
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default Settings;
